module.exports = require("react-dom/server");


//////////////////
// WEBPACK FOOTER
// external "react-dom/server"
// module id = 28
// module chunks = 0